<div class="processing-modal-container">
    <div class="processing-modal-content">
        <div class="processing-icon-container" [class.error-container]="error">
            <i *ngIf="!error" class="fas {{cyclingIcon}} processing-icon"></i>
            <i *ngIf="error" class="fas fa-exclamation-triangle processing-error-icon"></i>
            <div class="processing-icon-shadow" *ngIf="!error"></div>
        </div>
        <h2 class="processing-header" [class.error-text]="error">{{error ? 'Error processing document' : currentTransitionHeader}}</h2>
        <p class="processing-description">{{error ? 'There was an error processing this document. Please close this modal, save, reload the page, then try again. If the problem persists, reach out to your administrator.' : "Please wait a moment while our algorithm processes. You'll be taken to the next step once it's complete."}}</p>
        <button class="btn btn-light-primary processing-cancel-btn" (click)="closeModal()" *ngIf="error">Close</button>
    </div>
</div>
